import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from './utills/axiosInstance';

export default function CallBack() {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('session_state');

    console.log(code,state);
    

    if (!code) {
      console.error("No code in URL");
      navigate("/", { replace: true });
      return;
    }

    if (code && state) {
      localStorage.setItem('oauth_in_progress', 'true');
      console.log("auth");
      
      axiosInstance.post('/auth/token', { code, state })
        .then((res) => {
          const { profile, access_token, role } = res.data;

          // STORE EMAIL IN LOCALSTORAGE
          localStorage.setItem('userEmail', profile.mail || profile.userPrincipalName);
          localStorage.setItem('token', access_token);
          localStorage.setItem('name', profile.displayName);
          localStorage.setItem('role', role);

          setProfile(profile);
          localStorage.removeItem('oauth_in_progress');
          window.history.replaceState({}, document.title, window.location.pathname);

          navigate("/dashboard", { replace: true });
        })
        .catch((err) => {
          localStorage.removeItem('oauth_in_progress');
          console.error('Login failed:', err.response?.data || err.message);
          navigate("/", { replace: true });
        });
    }
  }, [navigate]);

  return <></>;
}